/**
 * Raw ticket actions types
 */

export const RAW_TICKETS_REQUESTED = '[RAW_TICKETS] REQUESTED';
export const RAW_TICKETS_SUCCEEDED = '[RAW_TICKETS] SUCCEEDED';
export const RAW_TICKETS_FAILED = '[RAW_TICKETS] FAILED';
export const RAW_TICKETS_NEXT_TICKET = '[RAW_TICKETS] NEXT TICKET';
export const RAW_TICKETS_PREV_TICKET = '[RAW_TICKETS] PREV TICKET';
